import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import style from './style.module.scss';

const Uuid = ({ uuid, intl }) => {
  const t = intl.messages.components.CarrierDetails;

  return (
    <div className={style.section}>
      <h2 className={style.sectionTitle}>{t.uuid_title}</h2>

      <div>{uuid ? <span>{uuid}</span> : <em>{t.uuid_missing}</em>}</div>
    </div>
  );
};

Uuid.propTypes = {
  uuid: PropTypes.string,
  intl: PropTypes.any,
};

export default injectIntl(Uuid);
